<template>
    <div class="sub-risk-dasboard-view">
        <div class="sub-risk-dasboard-view-header col-xs-12">
            <div class="sub-risk-dasboard-view-letter-box col-xs-3" id="overall-risk-letter-box"
                 :style="{'background-color':'#'+data_source.background}"
                 @mouseover="showTooltip(data_source.risk_letter_tooltip, $event)"
                 @mouseout="hideTooltip()">
                <div class="letter" style="top: 3px;">
                    {{data_source.risk_letter}}
                </div>
            </div>
            <div class="sub-risk-dasboard-view-content col-xs-8">
                {{customer_name}} <br> {{data_source.risk_group_header}}:
                {{fixedRiskPercent}}%
                <br>
                <div class="line" style="border-bottom: 1px solid #FAFAFA; width: 142%"></div>
            </div>
            <div class="logo-and-actions col-xs-1">
                <button id="send-threat-email-partner-button" @click="send_threat_email_child(files.enterprise_id)" :disabled="is_send_threat_email_disabled">
                    <!--Send Threat Email-->
                    <img @mouseover="showTooltip('Send Threat Email', $event)"
                         @mouseout="hideTooltip()" src="../../assets/mail.png" alt="Send Threat Email" style="width: 26px; height: 18px">
                </button>
                <img id="send-threat-email-partner-indicator" src="../../assets/mail-loading.gif" style="display: none">
            </div>
        </div>
        <div class="sub-risk-dasboard-view-description-box col-xs-12">
            <p style="padding-left: 2px; padding-top: 2px; padding-right: 2px">
                {{data_source.risk_group_description}}</p>
        </div>
        <div class="sub-risk-dasboard-view-area col-xs-12">
            <div class="sub-risk-dasboard-view-risks col-xs-12" v-for="file in data_source.risk_elements">
                <div class="sub-risk-dasboard-view-risks-letter col-xs-2"
                     :style="{'background-color':'#'+file.risk_level_bg}">
                    <div class="letter-other-risks" style="right: 3px; left: 3px; position: absolute;">
                        <p style="padding-top: 2px; padding-right: 0px;">{{file.risk_level}}</p>
                    </div>
                </div>
                <div class="sub-risk-dasboard-view-other-risks-content col-xs-7">
                    <div class="sub-risk-dasboard-view-other-risks-content-riskname col-xs-12">
                        <a v-if="file.issue_count" @click="clickRisk(file.risk_element_header)" :href=file.path
                           style="text-decoration: none; color: white !important;">
                            {{file.risk_element_header}}
                        </a>
                        <p v-if="!file.issue_count">{{file.risk_element_header}}</p>
                    </div>
                </div>
                <div class="sub-risk-dasboard-view-other-risks-content-issues col-xs-3">
                    <a v-if="file.issue_count" @click="clickRisk(file.risk_element_header)" :href=file.path
                       style="text-decoration: none; color: white !important;">
                        {{file.issue_count}} Issues
                    </a>
                    <p v-if="!file.issue_count">{{file.issue_count}} Issues</p>
                </div>
            </div>
        </div>
        <global-tooltip ref="tooltip"></global-tooltip>
    </div>
</template>

<script>

    import Constants from '@/utils/constants'
    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';
    import GlobalTooltip from '@/components/tooltip/GlobalTooltip.vue'
    import Common from '@/utils/Common.vue'

    export default {
        name: "sub-risk-dasboard-view",
        components: {
            GlobalTooltip: GlobalTooltip
        },
        comments: {},
        props: {
            is_send_threat_email_disabled: {
                type: Boolean,
                required: false
            },
            send_threat_email: {
                type: Function,
                required: false
            },
            files: {
                type: Object,
                required: true
            },
        },
        mixins: [Common],
        data() {
            return {
                data_source: {},
                customer_name: "",
                pageName: "Threat Score Widget"
            }
        },
        methods: {
            send_threat_email_child(enterprise_id) {
                this.$emit('send_threat_email', enterprise_id);
            },
            bindData(data_source, customer_name) {
                this.data_source = data_source;
                this.customer_name = customer_name;
            },
            clickRisk(subRiskName) {
                // this.$emit('this.notificationExtendable', this.getNotificationExtendable);
                // this.notificationExtendable(this.getNotificationExtendable);
                let log_start = Date.now();
                // console.log(log_start);
                this.setNotificationExtendable(true);
                this.saveLog(this, this.pageName, this.pageName + ' Sub Category clicked under ' + this.data_source.risk_group_header + '. Sub-Category: (' + subRiskName + ')', this.getDurationInSeconds(log_start, Date.now()), null);
            },
            showTooltip(text, e) {
                this.$refs.tooltip.showTooltip(e.clientY + 10, e.clientX + 10, text);
            },
            hideTooltip() {
                this.$refs.tooltip.hideTooltip();
            },
            ...mapActions([
                "setNotificationExtendable"
            ])
        },
        computed: {
            fixedRiskPercent: function () {
                if (this.data_source.percentage != null)
                    return this.data_source.percentage.toFixed();
            },
            ...mapGetters([
                "getNotificationExtendable"
            ])
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .logo-and-actions {
        font-family: Digital-Serial-Bold;
        margin-right: 8px;
    }

    .logo-and-actions button {
        background: black;
        border: 0;
        color: white;
        font-size: 16px;
        /*margin-left: 100px;*/
        margin-top: 18px;
        margin-left: 8px;
    }
    .sub-risk-dasboard-view-header {
        margin-bottom: 5px;
    }

    .sub-risk-dasboard-view-letter-box {
        height: 50px;
        width: 50px;
        text-align: center;
        font-size: 32px;
        color: white;
        font-family: Titillium Web Bold;
        margin-top: 20px;
    }

    .sub-risk-dasboard-view-description-box {
        width: 100%;
        background-color: black;
        height: 75px;
        margin-top: 5px;
        margin-bottom: 20px;
        -ms-word-wrap: break-word;
        word-wrap: break-word;
        font-family: Titillium Web Regular;
        color: white;
    }

    .sub-risk-dasboard-view-area {
        overflow-y: scroll;
        overflow-x: hidden;
        padding-left: 5px;
        box-sizing: content-box;
        position: relative;
        /*z-index: 6;*/
        height: 300px;
        margin-left: -37px;
    }

    .sub-risk-dasboard-view-area::-webkit-scrollbar {
        display: none;
    }

    .sub-risk-dasboard-view-content {
        font-size: 20px;
        color: white;
        font-family: Digital-Serial-Bold;
        margin-top: 15px;
    }

    .sub-risk-dasboard-view-risks {
        margin-bottom: 12px;
        margin-left: 35px;
        height: 24px !important;
    }

    .sub-risk-dasboard-view-risks-letter {
        height: 27px;
        width: 60px;
        color: white;
        line-height: 95%;
        font-family: Titillium Web Bold;
        font-size: 12px;
        text-align: center;
        word-wrap: break-word;
        border-radius: 7px;
        letter-spacing: 1px;
    }

    .sub-risk-dasboard-view-other-risks-content {
        font-family: Digital-Serial-Bold;
    }

    .sub-risk-dasboard-view-other-risks-content-riskname {
        font-size: 13px;
        color: white;
        margin-top: 5px;
    }

    .sub-risk-dasboard-view-other-risks-content-issues {
        font-size: 13px;
        color: white;
        margin-top: 5px;
        text-align: right;
        font-family: Digital-Serial-Bold
    }
</style>



// WEBPACK FOOTER //
// src/components/risk-score/SubRiskDashboardView.vue